import React from "react";
import postTask from './taskPost.png';
import "./PageThree.css";
import { Button } from "react-bootstrap";
import { fadeInLeft, fadeInRight } from 'react-animations';
import Radium, { StyleRoot } from 'radium';

const styles = {
  fadeInLeft: {
    animation: 'x 3s',
    animationName: Radium.keyframes(fadeInLeft, 'fadeInLeft')
  },
  fadeInRight: {
    animation: 'x 3s',
    animationName: Radium.keyframes(fadeInRight, 'fadeInRight')
  }
}
const PageThree = (props) => {

  const { onPageNumberClick } = props;

  return (
    <StyleRoot>
      <main
        className="pt5 black-80 congratulations"
      >
        <div className="contain" style={styles.fadeInLeft}>
          <div className="done">
            <img src={postTask} alt='Congratulations' className="img-fluid" />
          </div>
          <div className="congrats">
            <h1>Congratulations</h1>
            <p className="regards">Your task has been posted. You'll be noticed as soon as you recieve an offer</p>
          </div>
          <div className='post-task-btn mt-4'>
            <Button type="button" className="btn btn-primary" onClick={() => onPageNumberClick("4")}>Done</Button>
          </div>
        </div>
      </main>
    </StyleRoot>
  );
}

export default PageThree;